import { render, staticRenderFns } from "./embedVideo.vue?vue&type=template&id=9136102e&"
import script from "./embedVideo.vue?vue&type=script&lang=js&"
export * from "./embedVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports